module.exports = __webpack_public_path__ + "img/logo.cbffdd12.png";